import {
  Clock, UserRound, ShieldCheck, Plane, Star, Headphones, BadgeDollarSign, EyeOff,
} from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { FEATURES } from "../../lib/data";

const ICONS = { Clock, UserRound, ShieldCheck, Plane, Star, Headphones, BadgeDollarSign, EyeOff };

export default function WhyChoose() {
  return (
    <section id="why" data-testid="why-section" className="px-4 pt-6 sm:pt-10">
      <div className="mx-auto max-w-6xl vb-panel p-4 sm:p-6 lg:p-8">
        <SectionHeading testId="why-heading">Why Choose Voor Black</SectionHeading>

        <div className="grid grid-cols-4 gap-x-1.5 sm:gap-x-4 gap-y-4 sm:gap-y-6 mt-5 sm:mt-8">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon];
            const slug = f.title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
            return (
              <Reveal
                key={f.title}
                delay={i * 0.06}
                className="flex flex-col items-center text-center min-w-0"
                data-testid={`why-item-${slug}`}
              >
                <div
                  className="rounded-full flex items-center justify-center mb-2 sm:mb-3 shrink-0"
                  style={{
                    width: "clamp(30px, 5.5vw, 64px)",
                    height: "clamp(30px, 5.5vw, 64px)",
                    border: "1.5px solid rgba(214,212,0,0.5)",
                    boxShadow: "0 0 10px rgba(214,212,0,0.15)",
                  }}
                >
                  <Icon
                    strokeWidth={1.5}
                    className="text-[#d6d400]"
                    style={{ width: "clamp(14px, 2.5vw, 28px)", height: "clamp(14px, 2.5vw, 28px)" }}
                  />
                </div>
                <h4
                  className="font-display font-bold uppercase tracking-[0.05em] text-[#f4f4ea] leading-tight"
                  style={{ fontSize: "clamp(8.5px, 1vw, 13px)" }}
                >
                  {f.title}
                </h4>
                <p
                  className="font-body text-[#8f9080] mt-1 leading-snug"
                  style={{ fontSize: "clamp(12px, 0.9vw, 12px)" }}
                >
                  {f.desc}
                </p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
